import { logger } from "../helpers/logger"
import { ErrorTypes, ErrorTexts, Notifications } from "../lib/constants"

export const handleErrors = (
  errorCode: any,
  seterrorPage: any,
  handleNotification?: any,
) => {
  switch (errorCode) {
    case +ErrorTypes.CONCURRENT_CONNECTION:
      console.error("CONCURRENT_CONNECTION")
      seterrorPage(ErrorTexts.CONCURRENT_CONNECTION)
      break
    // case +ErrorTypes.INVALID_MESSAGE:
    //   console.error("INVALID_MESSAGE", errorCode)
    // handleNotification(Notifications.invalidBet)
    //   break
    case +ErrorTypes.GENERAL_ERROR: //generalErrorSession
      logger.log("SYSTEM_ERROR", errorCode)
      seterrorPage(ErrorTexts.SYSTEM_ERROR)
      break
    case +ErrorTypes.ALREADY_LOGGED_IN:
      console.error("GENERAL_ERROR", errorCode)
      handleNotification(Notifications.invalidAction)
      break
    case +ErrorTypes.INVALID_SERVICE:
    case +ErrorTypes.NOT_LOGGED_IN:
    case +ErrorTypes.SESSION_CLOSED:
    case +ErrorTypes.INVALID_MESSAGE:
      console.error("INVALID_SERVICE")
      seterrorPage(ErrorTexts.INVALID_SESSION)
      break

    case +ErrorTypes.INVALID_TRANSFER:
      console.error("INVALID_TRANSFER")
      seterrorPage(ErrorTexts.MONEY_TRANSFER_ERROR)
      break

    case +ErrorTypes.INVALID_BET:
    case +ErrorTypes.INVALID_BET_AMOUNT:
      console.error("INVALID_BET")
      handleNotification(Notifications.invalidBet)
      break
    case +ErrorTypes.MAX_BET_LIMIT:
      console.error("MAX_BET_LIMIT")
      handleNotification(Notifications.maxbetlimit)
      break
    case +ErrorTypes.INSUFFICIENT_FUNDS:
      console.error("INSUFFICIENT_FUNDS")
      handleNotification(Notifications.notEnoughBalance)
      break
    case +ErrorTypes.RETRY:
      console.error("INSUFFICIENT_FUNDS")
      handleNotification(Notifications.tryingtoreconnect)
      break
    case +ErrorTypes.INVALID_SESSION:
      console.error("INVALID_SESSION")
      seterrorPage(ErrorTexts.INVALID_SESSION)
      break

    // case +ErrorTypes.MONEY_TRANSFER_ERROR:
    //   console.error("MONEY_TRANSFER_ERROR")
    //   seterrorPage(Notifications.moneyTransferError)
    //   break
    // case +ErrorTypes.PF_NOT_SET:
    //   console.error("PF_NOT_SET")
    //   handleNotification(Notifications.cantChangeSeed)
    //   break
    // case +ErrorTypes.CLIENT_SEED_ERROR:
    //   console.error("CLIENT_SEED_ERROR")
    //   seterrorPage(ErrorTexts.CLIENT_SEED_ERROR)
    //   break
    // case +ErrorTypes.CLIENT_SEED_OK:
    //   console.error("CLIENT_SEED_OK")
    //   seterrorPage(ErrorTexts.CLIENT_SEED_OK)
    //   break
    // case +ErrorTypes.SYSTEM_ERROR:
    //   console.error("SYSTEM_ERROR")
    //   seterrorPage(ErrorTexts.SYSTEM_ERROR)
    //   break
    // case +ErrorTypes.INVALID_ACTION:
    //   console.error("INVALID_ACTION")
    //   handleNotification(Notifications.invalidAction)
    //   break
    // case +ErrorTypes.SEAT_TAKEN:
    //   console.error("SEAT_TAKEN")
    //   seterrorPage(ErrorTexts.SEAT_TAKEN)
    //   break
    // case +ErrorTypes.NOT_FOUND:
    //   console.error("NOT_FOUND")
    //   handleNotification(Notifications.notFound)
    //   break
    // case +ErrorTypes.GAME_NOT_ACTIVE:
    //   console.error("GAME_NOT_ACTIVE")
    //   seterrorPage(ErrorTexts.GAME_NOT_ACTIVE)
    //   break
    // case +ErrorTypes.JACKPOT_NOT_ACTIVE:
    //   console.error("JACKPOT_NOT_ACTIVE")
    //   seterrorPage(ErrorTexts.JACKPOT_NOT_ACTIVE)
    //   break
    // case +ErrorTypes.FAUCET_ERROR:
    //   console.error("FAUCET_ERROR")
    //   seterrorPage(ErrorTexts.FAUCET_ERROR)
    //   break
    // case +ErrorTypes.INSUFFICIENT_RAISE_FUNDS:
    //   console.error("INSUFFICIENT_RAISE_FUNDS")
    //   handleNotification(Notifications.insufficientRaiseFunds)
    //   break
    case +ErrorTypes.STAGE_TIMEOUT:
      console.error("STAGE_TIMEOUT")
      // handleNotification(Notifications.stageTimeout)
      break
    default:
      console.error("CONNECTION_LOST ", errorCode)
      seterrorPage(ErrorTexts.CONNECTION_LOST)
      break
  }
}
